<template>
  <div>
    <TheCouponsIndex />
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";

export default {
  name: "TemplateMyCouponsIndex",
  setup() {
    const store = useStore();
    const coupons = computed(() => store.getters["coupon/externalCoupons"]);

    return {
      coupons,
    };
  },
};
</script>
